<template>
  <div role="button" v-on="$listeners" class="export-button robotoR">
    <div class="export-text-div">
      <span class="export-text"><slot>export</slot></span>
      <FontAwesomeIcon class="export-icon" icon="file-download"/>
    </div>
  </div>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faFileDownload} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

library.add(faFileDownload);

export default {
  name: 'ExportButton',
  components: {
    FontAwesomeIcon
  }
};
</script>

<style>
.export-button {
  @apply inline-block align-middle select-none text-center cursor-pointer bg-white;
  border: 1px solid #d3d3d6;
  border-radius: 4px;
  line-height: 1.42857143;
  white-space: nowrap;
  font-size: 12px;
  padding: 6px 9px;
  outline: none !important;

  &:hover {
    color: #0989ff;
    border-color: rgba(9, 147, 255, 0.6);
  }

  &:active {
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .13);
  }

  .export-text-div {
    color: #0B4D8E;

    .export-text {
      @apply font-bold inline-block align-middle;
      margin: 1px 0 0;
      color: #0B4D8E;
    }

    .export-icon {
      @apply inline-block align-middle mt-0 ml-1;
    }
  }

  &[disabled] {
    @apply cursor-default opacity-60 shadow-none pointer-events-none;
  }
}
</style>